<template>
	<layout-splash title="Reset Password">
		<div class="h-full w-96">
			<h1 class="bg-green text-3xl px-6 py-4 text-white font-bold">
				{{ __("Reset Password") }}
			</h1>

			<form class="flex flex-col pt-4 space-y-4">
				<div
					v-if="success"
					class="rounded-lg text-green-500 bg-green-100 font-medium mx-3 px-3 py-2"
				>
					{{ success }}
				</div>
				<div
					v-else-if="error"
					class="rounded-lg text-red-600 bg-red-100 font-medium mx-3 px-3 py-2"
				>
					{{ error }}
				</div>

				<div class="px-6">
					<ui-input-group
						v-model="form.email"
						field="email"
						label="E-Mail"
						:form="form"
						:required="true"
					></ui-input-group>
				</div>

				<div class="flex justify-end pt-4 pb-6 px-6 bg-gray-50 sm:rounded-b-xl">
					<ui-button v-on:click="submit()" type="primary">{{
						__("Reset Password")
					}}</ui-button>
				</div>
			</form>
		</div>
	</layout-splash>
</template>

<script>
export default {
	props: {
		success: {
			type: String,
		},
		error: {
			type: String,
		},
	},
	data() {
		return {
			form: this.$inertia.form({
				email: "",
			}),
		};
	},
	methods: {
		submit() {
			this.form.post(this.$route("password.email"));
		},
	},
};
</script>
